import {Injectable, Injector} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SessionService} from './session.service';
import {NzMessageService} from 'ng-zorro-antd/message';

@Injectable()
export class GraphqlInterceptor implements HttpInterceptor {

  private readonly notifier: NzMessageService;
  private mapper = {
    '/function/': (request: HttpRequest<any>): HttpRequest<any> => {
      return request.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + this.sess.getAccessToken())
      });
    },
    '/ords-': (request: HttpRequest<any>): HttpRequest<any> => {
      return request.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + this.sess.getAccessToken())
      });
    },
  };

  constructor(private injector: Injector, private sess: SessionService) {
    this.notifier = this.injector.get(NzMessageService);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    Object.keys(this.mapper).forEach((key) => {
      if (request.url.startsWith(key)) {
        request = this.mapper[key](request);
      }
    });
    return next.handle(request);
  }


}
